import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";

export enum ButtonVariant {
  PRIMARY = "PRIMARY",
  PRIMARY_OUTLINE = "PRIMARY_OUTLINE",
  SECONDARY = "SECONDARY",
  SECONDARY_OUTLINE = "SECONDARY_OUTLINE",
  DARK = "DARK",
  DANGER = "DANGER",
}

export interface ButtonConfig {
  text: string;
  class?: string;
  variant?: ButtonVariant;
  disabled?: boolean;
}

@Component({
  selector: "thera-button",
  standalone: true,
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
  imports: [MatButtonModule, CommonModule],
})
export class ButtonComponent implements OnInit {
  @Input() config!: ButtonConfig;
  @Input() disabled = false;
  @Input() iconOnly = false;
  @Input() type = "button";
  @Output() clicked: EventEmitter<any> = new EventEmitter();
  buttonVariant = ButtonVariant;

  ngOnInit() {
    if (!this.config.variant) {
      this.config.variant = ButtonVariant.PRIMARY;
    }
    this.disabled = this.config.disabled ?? this.disabled;
  }

  onButtonClick(event: MouseEvent) {
    if (!this.disabled) {
      this.clicked.emit(event);
    }
  }
}
